<template>
  <a
    class="d-flex justify-content-center cursor-pointer"
    v-b-tooltip.hover="{ variant: 'base' }"
    :title=file_name
    :href="download_url"
  >
    <font-awesome-icon icon="file-invoice" />
  </a>
</template>

<script>
export default {
  props: {
    file_name: {
      type: String,
      required: true
    },
    download_url: {
      type: String,
      required: true
    }
  }
}
</script>
